package com.macrofocus.eflux.theme

import mui.material.CssBaseline
import mui.material.styles.Theme
import mui.system.ThemeProvider
import react.*

typealias ThemeState = StateInstance<Theme>

val ThemeContext = createRequiredContext<ThemeState>()

val ThemeModule = FC<PropsWithChildren> { props ->
    val state = useState(Themes.Light)
    val (theme) = state

    ThemeContext(state) {
        ThemeProvider {
            this.theme = theme

            CssBaseline()
            +props.children
        }
    }
}